<template>
  <!-- <div id="container" ref="mapRef" class="mainBox"> -->
    <div id="container" class="mainBox">
      <!-- <iframe  id="iframeContain"  name="iframeContain"  seamless  scrolling="yes"  src="http://lcdata.laicun.wang/bd/3dmap" ></iframe>
 -->
      <iframe src="3dmap" style="width:100%;height:100%;border: none;"></iframe>
       <!--顶部  -->
      <div class="navBox"><Nav curNavId="6" pathUrl='binghai' @circle="clickNav" /></div>
        <!-- z左侧 -->
        <div class="left">
          <div class="leftBox1">
            <div class="title">数据中心<img src="../assets/img/gbzntyj/gaungai/fk.png" class="titIcon" /></div>
            <div class="leftBox1Content">
              <div class="leftBox1ContentTop">
                <div class="circle"></div>
                <img src="../assets/img/gbzntyj/gaungai/gg.png" class="circleImg" />
                <div class="leftBox1ContentTopList" v-if="state.showDiv">
                  <div v-for="(item,index) in state.leftData1A" :key="index" class="leftBox1ContentTopItem  animate__animated" :class="index==0||index==2 ? 'animate__fadeInLeft' : 'animate__fadeInRight'">
                        <div class="contentLine contentLine1"></div>
                        <div class="contentLine contentLine2"></div>
                        <div class="contentLine contentLine3"></div>
                        <div class="contentLine contentLine4"></div>
                        <span class="txt1">{{item.name}}</span><span class="txt2">{{item.value}}{{item.unit}}</span>
                  </div> 
                </div>
              </div>
              <div class="leftBox1ContentCenter">
                <div class="dateItem" :class="{dateItemCur:state.left1Cur==index}" v-for="(item,index) in state.leftData1Date" :key="index" @click.stop="tabDate(index)">{{item}}</div>
              </div>
              <div class="leftBox1ContentBottom">
                <div class="leftBox1ContentBottom1 animate__animated animate__fadeInLeft"  v-if="state.showDiv">
                  <div class="leftBox1ContentBottomItem" v-for="(item,index) in state.leftData1B" :key="index">
                  <div class="leftItem"><img :src="item.icon" /></div>
                  <div class="rightCon"><span class="txt1">{{item.value}}</span><span class="txt2">{{item.name}}</span></div>
                </div>
              </div>
                
              </div>
            </div>
          </div>
          <div class="leftBox2">
            <div class="title">水肥变化量<img src="../assets/img/gbzntyj/gaungai/fk.png" class="titIcon" /></div>
            <div class="echartBox" ><LeftBar /></div>
          </div>
        </div>
        <!-- 右侧 -->
        <div class="right">
          <div class="rightBox1" id="video1">
            <div class="title">视频监控<img src="../assets/img/gbzntyj/gaungai/fk.png" class="titIcon" /></div>
            <div class="videoBox">
              <div class="videoBg">
                <div class="contentLine contentLine1"></div>
                <div class="contentLine contentLine2"></div>
                <div class="contentLine contentLine3"></div>
                <div class="contentLine contentLine4"></div>
                <!-- <vue3VideoPlay id="video"  ref="videoRef"  width="100%"  height="100%" title="视频监控" :src="options.src" :type="options.type" :autoPlay="true"  :muted="true" :control="false"  @loadedmetadata="onLoadedMetadata"/> -->
                <img src="../assets/img/gbzntyj/video1.jpg" style="width:100%;height:100%;" @click="videoClick"/>
              </div>
              <div class="videoTabList"><div class="videoTabItem" v-for="(item,index) in state.tabList" :key="index">{{item}}</div></div>
            </div>
            <!-- <div class="videoBox">
              <div class="videoKz">
                <div class="rightBox1_r_top_item" v-for="(item,index) in rightKz" :key="index">
                  <h6>{{item.name}}</h6>
                  <div class="rightBox1_r_top_status"><span :class="{isOpen:item.isOpen}" @click="clickIsOpen(index,0)">开启</span><span :class="{isClose:!item.isOpen}" @click="clickIsOpen(index,1)">关闭</span></div>
                </div>
              </div>
              <div class="videoBg">
                <div class="contentLine contentLine1"></div>
                <div class="contentLine contentLine2"></div>
                <div class="contentLine contentLine3"></div>
                <div class="contentLine contentLine4"></div>
                <vue3VideoPlay  width="100%"  height="100%"  title="视频监控"  :src="options1.src"    :type="options.type"  :autoPlay="true" :control="false" />
              </div>
              <div class="videoTabList"><div class="videoTabItem" v-for="(item,index) in tabList" :key="index">{{item}}</div></div>
            </div> -->
          </div>
          <div class="rightBox3">
            <div class="title">灌溉方式及面积<img src="../assets/img/gbzntyj/gaungai/fk.png" class="titIcon" /></div>
            <div class="echartBox"><RightPie /></div>
          </div>
          <div class="rightBox2">
            <div class="title">灌溉水量<img src="../assets/img/gbzntyj/gaungai/fk.png" class="titIcon" /></div>
            <div class="echartBox"><rightLine /></div>
          </div>
        </div>

  </div>
  <CircleNav :isShow="state.circleShow"  @closeCircle1="circleHiddlen"  />
  <footer1 />
   <popBg title="智能灌溉" :popShow="state.popShow" @hiddlen="popHiddlen">
    <!-- <vue3VideoPlay id="video"  width="100%"  height="100%"  title="冰河世纪"  :src="videoList[curVideoIndex].options.src"  :type="videoList[curVideoIndex].options.type"  :autoPlay="true"/> -->
      <div class="popInfo">
        <div class="videoBox">
          <div style="width: 100%; height: 100%" v-if="state.AccessToken != ''">
            <iframe :src="state.options.src + state.AccessToken" width="100%"  height="100%" id="ysOpenDevice" allowfullscreen></iframe>
          </div>
        </div>
        <div class="openBtn" @click="clickOpen">
          {{state.isOpen?'关闭':'打开'}}
        </div>
      </div>

  </popBg>
</template>

<script setup>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from "vue-router";

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  computed,
  onBeforeUnmount,
  getCurrentInstance,
  defineEmits,
  watch
} from "vue";

// todo 项目使用请放开 leaflet 引入
// import L from "leaflet";
// import "leaflet/dist/leaflet.css";
// // import * as L from 'leaflet/dist/leaflet.esm.js';
// import Gep from "../utils/范围面.json";
// import ldt from "../components/gbzntyj/ldt.vue";
// import dczz from "../components/gbzntyj/dczz.vue";
import LeftBar from "../components/ZhinengGG/LeftBar"
import rightLine from "../components/ZhinengGG/rightLine"
import RightPie from "../components/ZhinengGG/RightPie"
import footer1 from "../components/footer.vue";
import Nav from "../components/nav.vue";
import popBg from "../components/popBg.vue";
import CircleNav from "@/components/circleNav.vue";
import {setRandomDate} from "@/utils/getRandomDate";


    let statusUpdateInterval;
    // const timer = ref(null);
    const router = useRouter();
    const videoRef = ref(null);
    const state = reactive({
      leftData1A:[{name:"总流量",value:"0.01",unit:"m³/h"},{name:"运行速度",value:"45.0",unit:"m/h"},{name:"水渠液位",value:"0.3",unit:"m"},{name:"运行时间",value:"0.3",unit:"h"}],
      // leftData1Date:["4.05","4.12","4.16","4.20","4.26","4.30","5.02",],
      leftData1Date:[],
      left1Cur:0,
      leftData1B:[{name:"灌溉水量",value:"0.00",unit:"m³",icon:require('@/assets/img/gbzntyj/gaungai/sl.png')},{name:"灌溉亩数",value:"0.00",unit:"亩",icon:require('@/assets/img/gbzntyj/gaungai/ms.png')},{name:"亩均灌溉量",value:"0.00",unit:"m³/亩",icon:require('@/assets/img/gbzntyj/gaungai/pj.png')}],
      showDiv:true,
      tabList:["固定喷灌","指针喷灌","平移喷灌","水肥一体机"],
      options: {
        src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/J57579282/1.live&autoplay=1&accessToken=", //视频源
        type: "m3u8", //视频类型
        },
      options1: {
        src: require("@/assets/video/gg.mp4"), //视频源
        type: "video/mp4", //视频类型
        },
        status:1,
        currentTime1:0,
        laststatus:0,
        isOpen:false,
        popShow:false,
        AccessToken:"",
      circleShow:false
    });

     onMounted(() => {
       state.leftData1Date = setRandomDate(5,1)
      state.AccessToken = localStorage.getItem('AccessToken')

    });
    function tabDate(index){
      state.showDiv = false; // 点击后先隐藏div
      state.left1Cur = index
      setTimeout(() => {
        state.showDiv = true; // 200ms后再重新显示div（模拟刷新）
      }, 200);
    }
    // 关闭弹出
    function popHiddlen() {
      state.popShow = false;
    }
// 弹出视频
    function videoClick() {
      state.popShow = true;
      // state.curVideoIndex = index;
    }
    
    // 灌溉开关
    function clickOpen(){
      if(!state.isOpen){
        axios
          .get("https://iot.laicunwang.com/st_change.php?id=5&type=5&status=start", {})
          .then((res) => {
            console.log(res)
            state.isOpen = true
            console.log("打开了",state.isOpen)
          })
      }else{
        axios
          .get("https://iot.laicunwang.com/st_change.php?id=5&type=5&status=stope", {})
          .then((res) => {
            console.log(res)
            state.isOpen = false
            console.log("关闭了",state.isOpen)
          })
      }

    }
    function clickNav(isShow){
      // console.log(isShow)
      state.circleShow = isShow.show
    }
    function circleHiddlen(data1){
      // console.log('circle')
      state.circleShow = data1.show
    }
    onUnmounted(() => {
      clearInterval(statusUpdateInterval);
    });
    onBeforeUnmount(() => {
      // clearInterval(timer.value);
    });

</script>
<style lang="less" scoped>
body {
  background-size: cover;
  line-height: 1.15;
  font-size: 14px;
  overflow: hidden;
}
#echartBox{
  font-size: 14px;
}
::v-deep .d-play-btn {
  width: 50px !important;
  height: 50px !important;
}
::v-deep .d-player-state{
  top: 50%;
  display: none;
}
::v-deep .d-icon{
  font-size: 20px!important;
}
::v-deep .d-player-wrap .d-player-control{
  height: 30px;
}
#video1 .d-player-wrap,#video2 .d-player-wrap  {
  object-fit: cover;
  // background-color: #ff0000 !important;
  background-color: transparent !important; /* 设置背景色为透明 */
}
.navBox{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 95px;
  background: linear-gradient( to bottom, rgba(0, 0, 0, 0.8) 0%,  rgba(0, 0, 0, 0.7) 50%,  rgba(0, 0, 0, 0));
}
#iframeContain{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
}
.mainBox {
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
  .containerBg{
    position: absolute;
    width: 100%;
    height: 100%;
    background: url("../assets/img/gbzntyj/bg.png") no-repeat;
    z-index: 999;
    top: 0;
    left: 0;
  }

    .left,.right{
      width: 572px;
      height: 100%;
      display: flex;
      flex-direction: column;
       position: absolute;
       top: 0;
       padding-top: 80px;
       box-sizing: border-box;
    }
    .title{
      width: 436px;
      height: 46px;
      background: url("../assets/img/gbzntyj/gaungai/xbt.png") no-repeat;
      font-size: 16px;
      color: #fff;
      text-align: left;
      font-weight: bold;
      line-height: 36px;
      padding-left: 54px;
      padding-top: 7px;
      box-sizing: border-box;
      margin-top: 10px;
      position: relative;
      letter-spacing: 3px;
      .titIcon{
        position: absolute;
        top: 11px;
        left: 13px;
        width: 28px;
        height: 28px;
        animation: titIcon 5s linear infinite;
        // animation-delay: 5s;
        
      }
    }
    .echartBox{
        width: 100%;
        flex: 1;
      }
    .left{
      left: 0;
      padding-left: 34px;
      background:url("../assets/img/gbzntyj/gaungai/zjb.png") no-repeat ;
      .leftBox1{
        width: 100%;
        height: 500px;
        display: flex;
        flex-direction: column;
        .leftBox1Content{
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .leftBox1ContentTop{
          width: 100%;
          height: 239px;
          background: url("../assets/img/gbzntyj/gaungai/x.png") no-repeat center center;
          position: relative;
          margin: 30px 0 40px;
          .circle{
            position: absolute;
            top: 50%;
            left: 50%;
            width: 239px;
            height: 239px;
            background: url("../assets/img/gbzntyj/gaungai/nq.png") no-repeat center center;
            margin: -120px 0 0 -120px;
            animation: guangying 2s linear infinite;
          }
          .circleImg{
              position: absolute;
              top: 50%;
              left: 50%;
              z-index: 999;
              width: 36px;
              height: 38px;
              margin: -19px 0 0 -18px;
              animation: left1Img 2s linear infinite;
              
            }
            .leftBox1ContentTopList{
              width: 100%;
              height: 100%;
              position: relative;
              .leftBox1ContentTopItem{
                width: 115px;
                height: 65px;
                background: url("../assets/img/gbzntyj/gaungai/llk.png") no-repeat;
                position: absolute;
                z-index: 9;
                overflow: hidden;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                span{
                  display: block;
                  font-size: 14px;
                }
                span.txt1{
                  color: #fff;
                  opacity: .9;
                }
                 span.txt2{
                  color: #00E9EF;
                  font-weight: bold;
                }
              }
              .leftBox1ContentTopItem:nth-child(1){
                top: -8px;
                left: 0;
              }
              .leftBox1ContentTopItem:nth-child(2){
                top: -8px;
                right: 0;
              }
              .leftBox1ContentTopItem:nth-child(3){
                bottom: -8px;
                left: 0;
              }
              .leftBox1ContentTopItem:nth-child(4){
                bottom: -8px;
                right: 0;
              }
            }
        }
        .leftBox1ContentCenter{
          width: 100%;
          height: 46px;
          background: url("../assets/img/gbzntyj/gaungai/rq.png") no-repeat;
          background-size: 100% 100%;
          line-height: 46px;
          padding: 0 60px;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
          .dateItem{
            font-size: 18px;
            color: #Fff;
            cursor: pointer;
          }
          .dateItem:hover,.dateItemCur{color: #ffc600;}
        }
        .leftBox1ContentBottom{
          width: 100%;
          flex: 1;
          .leftBox1ContentBottom1{
            display: flex;
            width: 100%;
            height: 100%;
          }
          .leftBox1ContentBottomItem{
            flex: 1;
            display: flex;
            font-size: 14px;
            margin: 20px 0;
            .leftItem{
              background: url("../assets/img/gbzntyj/gaungai/slk.png") no-repeat;
              width: 50px;
              height: 48px;
              display: flex;
              justify-content: center;
              align-items: center;
              img{
                width: 25px;
                height: 27px;
                animation: left1Img 1s linear infinite;
              }
            }
            .rightCon{
              display: flex;
              flex-direction: column;
              margin-left: 10px;
              span{
                display: block;
                text-align: left;
              }
              span.txt1{
                color: #00F6F8;
                font-weight: bold;
              }
              span.txt2{
                color: #fff;
              }
            }
          }
        }
        }
        
      }
      .leftBox2{
        flex: 1;
        width: 100%;
        display: flex;
        flex-direction: column;
      }
      
    }
    .right{
      right: 0;
      background:url("../assets/img/gbzntyj/gaungai/yjb.png") no-repeat ;
      padding-right: 34px;
      align-items: flex-end;
      .rightBox1{
        height: 360px;
        display: flex;
        flex-direction: column;
        .videoBox{
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          margin: 10px 20px 0;
          width: 396px;
          .videoBg{
            background: url("../assets/img/gbzntyj/gaungai/spk.png") no-repeat;
            background-size: 100% 100%!important;
            width: 396px;
            height: 228px;
            padding: 5px;
            box-sizing: border-box;
            position: relative;
            overflow: hidden;
          }
          .videoTabList{
            display: flex;
            height: 44px;
            justify-content: space-between;
            // margin-top: 10px;
            .videoTabItem{
              width: 80px;
              height: 44px;
              background: url("../assets/img/gbzntyj/gaungai/pg.png") no-repeat;
              font-size: 14px;
              color: #04DFE4;
              text-align: center;
              line-height: 44px;
            }
          }
          .videoKz{
            width: 100%;
            height: 100%;
            display: flex;
          }
          .rightBox1_r_top_item{
              width: 45%;
              h6{
                  color: #fff;
                  line-height: 50px;
                  text-align: left;
                  font-size: 26px;
                  font-weight: normal;
                  margin: 10px 0;
              }
               .rightBox1_r_top_status{
                  display: flex;
                  justify-content: space-between;
                  span{
                    display: block;
                    width: 128px;
                    height: 50px;
                    text-align: center;
                    line-height: 50px;
                    background: #05232E;
                    color: #00798B;
                    border-radius: 6px;
                    font-size: 26px;
                    cursor: pointer;
                  }
                  span.isOpen{
                    background: #0CB3A5;
                    color: #fff;
                  }
                  span.isClose{
                    background: #DE5954;
                    color: #fff;
                  }
              }
          }
        }
      }
      .rightBox2{
        flex: 1;
        width: 436px;
        display: flex;
        flex-direction: column;
      }
      .rightBox3{
        flex: 1;
        display: flex;
        flex-direction: column;
      }
    }
    



}
.popInfo{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  .videoBox{
    width: 100%;
    height:100%;
  }
  .openBtn{
    position: absolute;
    left: 50%;
    bottom: 0px;
    background: url("../assets/img/gbzntyj/gaungai/kg.png") no-repeat;
    width: 193px;
    height: 102px;
    z-index: 1000;
    margin-left: -97px;
    color: #fff;
    line-height: 102px;
    font-size: 18px;
  }
}

@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}
@keyframes left1Img {
  /*引用动画名称*/
  0% {
    transform: scale(1);
  }
50% {
    transform: scale(0.8);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes left2Img {
  /*引用动画名称*/
  0% {
    margin-top: 0;
  }
50% {
    margin-top: 5px;
  }
  100% {
    margin-top: 0;
  }
}
@keyframes titIcon {
  /*引用动画名称*/
  0% {
    transform: rotateY(0);
  }
  50% {
    transform: rotateY(180deg);
     animation-delay: 5s;
  }
  100% {
    transform: rotateY(0);
   
  }
}

.contentLine {
  background: #1AA19E;
  position: absolute;
}
.contentLine1{
  top: 1px;
  left: 0;
  width: 10%;
  height: 2px;
  /* 加上渐变效果，方可形成拖尾效果 */
  background: linear-gradient(90deg, transparent, #1AA19E);
  animation: animate1 4s linear infinite;
}
.contentLine2{
  top: -100%;
  right: 0;
  width: 2px;
  height: 20%;
  background: linear-gradient(180deg, transparent, #1AA19E);
  animation: animate2 4s linear infinite;
  /* 注意要加上延时触发动画效果，这样线条才会依次触发 */
  animation-delay: 1s;
}
.contentLine3{
  bottom: 1px;
  right: 0;
  width: 20%;
  background: linear-gradient(270deg, transparent, #1AA19E);
  animation: animate3 4s linear infinite;
  animation-delay: 2s;
}
.contentLine4{
  bottom: -100%;
  left: 1px;
  width: 2px;
  height: 10%;
  background: linear-gradient(360deg, transparent, #1AA19E);
  animation: animate4 4s linear infinite;
  animation-delay: 3s;
}
/* 定义关键帧 */
@keyframes guangying {    /*引用动画名称*/
0% {
      transform: rotate(0deg);
  }

100% {
  transform: rotate(-360deg);
}
}

@keyframes animate1 {
0% {
    left: -50%;
}

50%,
100% {
    left: 100%;
}
}

@keyframes animate2 {
0% {
    top: -100%;
}

50%,
100% {
    top: 100%;
}
}
@keyframes animate3 {
0% {
    right: -100%;
    height: 3px;
}

50%,
100% {
    height: 2px;
    right: 100%;
}
}
@keyframes animate4 {
0% {
    bottom: -100%;
}

50%,
100% {
    bottom: 100%;
}
}
@keyframes topIcon {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(15deg);
    transform: scale(.9);
  }
  75% {
    transform: rotate(-15deg);
    // transform: scale(.9);
  }
   100% {
    transform: rotate(0);
  }
}
</style>
